"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80840],{

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};



/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 12 modules
var websocket_pb = __webpack_require__(24513);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx


















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        (ref = socket.current) === null || ref === void 0 ? void 0 : ref.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 80341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .sysmsg-alert {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0;\n\n    .anticon {\n      display: none;\n    }\n\n    & > div {\n      background: transparent;\n      padding: 0;\n    }\n\n    & > div > div > span > {\n      .message-success {\n        background: #e1f6e5;\n        color: ",
        ";\n      }\n\n      .message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-warning {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-info {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-default {\n        border-radius: 5px;\n        padding: 10px 15px;\n      }\n\n      .alert-snackbar {\n        font-family: var(--font-bold);\n        font-weight: 600;\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 4px;\n        padding: 15px 20px;\n        max-width: 317px;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      .alert-plain,\n      .alert-plain-default {\n        font-family: var(--font-regular);\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        line-height: 16.1px;\n        max-width: 300px;\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-snackbar-dark {\n        font-family: var(--font-bold);\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 15px 20px;\n        max-width: 317px;\n        min-width: 335px;\n        position: relative;\n        border-radius: 4px;\n\n        span {\n          margin: 0 12px 0 8px;\n        }\n\n        background: #3b3b3b;\n        color: ",
        ";\n\n        .notif-close-icon {\n          position: absolute;\n          right: 20px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var alertStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertRed */ .Z.alertRed, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertOrange */ .Z.alertOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].alertBlue */ .Z.alertBlue, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].valencia */ .Z.valencia, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].valencia */ .Z.valencia, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = (alertStyles);


/***/ }),

/***/ 42959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainApp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 3 modules
var queryClient = __webpack_require__(51767);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/global/Scripts/google.js
/* eslint-disable react/no-danger */ 




var Google = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: app/* STAGE */.or !== "development",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
            children: app/* GTM_ID */.Ax ? // eslint-disable-next-line @next/next/next-script-for-ga
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-manager",
                strategy: "afterInteractive",
                children: "\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&ra='+Date.now();f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer', '".concat(app/* GTM_ID */.Ax, "');\n              ")
            }) : null
        })
    });
};
/* harmony default export */ var google = (Google);

// EXTERNAL MODULE: ./src/lib/store.ts + 33 modules
var store = __webpack_require__(61805);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/config/theme.ts
var theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/global/GlobalStyles/alert.ts
var GlobalStyles_alert = __webpack_require__(80341);
;// CONCATENATED MODULE: ./src/global/GlobalStyles/tooltip.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .tooltip-overlay-green {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-dark {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-red {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-transparent {\n    cursor: pointer;\n    padding-top: 0 !important;\n    .ant-tooltip-arrow-content {\n      display: none;\n      background: transparent;\n      box-shadow: unset;\n\n      ::before {\n        transparent;\n      }\n    }\n    \n    .ant-tooltip-inner { \n      background: transparent;\n      border-radius: 4px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var tooltipStyles = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), color/* default.primary */.Z.primary, color/* default.highempahis */.Z.highempahis, color/* default.highempahis */.Z.highempahis, color/* default.sunsetOrange */.Z.sunsetOrange, color/* default.sunsetOrange */.Z.sunsetOrange);
/* harmony default export */ var tooltip = (tooltipStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/layout.ts

function layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .chat-page-layout-container {\n    padding-top: 60px !important;\n    margin-top: unset !important;\n    padding-right: 0px !important;\n\n    @media ",
        " {\n      padding-top: 120px !important;\n    }\n\n    @media ",
        " {\n      max-width: 1300px;\n      margin: 100px auto 0;\n    }\n  }\n"
    ]);
    layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var layoutPageContainerStyles = (0,styled_components_browser_esm/* css */.iv)(layout_templateObject(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
/* harmony default export */ var layout = (layoutPageContainerStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/index.js

function GlobalStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Wave Color */\n  html {\n    --antd-wave-shadow-color: ",
        ";\n  }\n\n  body {\n    background-color: #f5f5f5;\n    font-family: var(--regular-font);\n    font-size: 14px;\n    height: auto;\n    font-variant: normal;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  b,\n  strong {\n    font-family: var(--bold-font);\n    font-weight: normal;\n  }\n\n  /* ANTD Modal */\n  /* .ant-modal-mask {\n    z-index: 1031;\n  }\n\n  .ant-modal-wrap {\n    z-index: 1040;\n  } */\n\n  /* Antd Popover */\n  .ant-popover-inner-content {\n    padding: 0;\n  }\n  .ant-popover-inner {\n    box-shadow: none;\n    border: none;\n  }\n  .ant-popover-arrow {\n    display: none;\n  }\n\n  .ant-popover-placement-bottomRight {\n    position: fixed;\n  }\n\n  /* Antd DatePicker */\n  .ant-picker-panel-container {\n    border: 1px solid ",
        ";\n  }\n\n  .ant-picker-decade-panel,\n  .ant-picker-year-panel,\n  .ant-picker-quarter-panel,\n  .ant-picker-month-panel,\n  .ant-picker-week-panel,\n  .ant-picker-date-panel,\n  .ant-picker-time-panel {\n    width: 230px;\n  }\n\n  .ant-picker-content {\n    table-layout: auto;\n    width: 100% !important;\n  }\n\n  .ant-picker-header-view {\n    font-size: 12px;\n    font-family: var(--font-bold);\n\n    button {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n  .ant-picker-cell-in-view {\n    font-family: var(--font-bold);\n  }\n  .ant-picker-footer {\n    display: block !important;\n  }\n  .ant-picker-today-btn {\n    font-size: 12px;\n    color: ",
        ";\n    font-family: var(--font-bold);\n    display: block !important;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n  .ant-picker-dropdown {\n    font-size: 10px !important;\n  }\n  .ant-picker-cell {\n    padding: 2px 0;\n  }\n\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border: none !important;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-content th {\n    font-weight: bold;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border-color: ",
        ";\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    color: unset;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {\n    background: ",
        " !important;\n    margin: -1px;\n  }\n\n  /* Antd Dropdown */\n  .ant-dropdown {\n    li {\n      height: 28px !important;\n      line-height: 28px !important;\n      padding: 0 10px !important;\n    }\n  }\n  .ant-dropdown-menu {\n    border: 1px solid #dadada;\n    border-radius: 0;\n    box-shadow: 0 0 10px ",
        ";\n    padding: 0px;\n  }\n\n  .ant-dropdown-menu-item,\n  .ant-dropdown-menu-submenu-title {\n    padding: 5px;\n\n    p {\n      color: ",
        ";\n    }\n\n    &:hover,\n    &.ant-dropdown-menu-item-active {\n      p {\n        color: ",
        ";\n      }\n    }\n\n    &:first-child {\n      border-radius: 3px 3px 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 0 3px 3px;\n    }\n  }\n\n  /* Antd Select */\n  .ant-select-item {\n    font-family: 'ProximaNovaRg';\n  }\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset;\n  }\n  .ant-select-dropdown {\n    box-shadow: none;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    div[aria-selected='true'] {\n      font-family: var(--bold-font);\n    }\n  }\n\n  /* Antd tag a */\n  a:hover {\n    color: ",
        ";\n  }\n\n  /* Antd autocomplete */\n  .ant-select-focused .ant-select-selector,\n  .ant-select-selector:focus,\n  .ant-select-selector:active,\n  .ant-select-selector:hover,\n  .ant-select-open .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  /* Antd modal */\n  .ant-modal-mask {\n    background-color: rgba(18, 18, 18, 0.5);\n  }\n\n  /* Antd Message */\n  .ant-message {\n    z-index: 999999; // TOP OF LAYER\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #616161 !important;\n    color: #cbcbcb;\n    border: none;\n\n    &:hover > p {\n      color: #cbcbcb;\n    }\n  }\n\n  body.disabled-popover-animation .ant-popover {\n    animation-duration: 0s !important;\n  }\n\n  body.no-scroll {\n    overflow: hidden;\n    width: 100% !important;\n  }\n"
    ]);
    GlobalStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root {\n    --font-regular: 'ProximaNovaRg', sans-serif;\n    --font-bold: 'ProximaNovaBd', sans-serif;\n  }\n\n  @keyframes placeHolderShimmer {\n    0% {\n      background-position: -468px 0;\n    }\n    100% {\n      background-position: 468px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n\n    :root {\n      --regular-font: \"ProximaNovaRg\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --bold-font: \"ProximaNovaBd\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --light-font: \"ProximaNovaLt\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    }\n\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 5px;\n    }\n    ::-webkit-scrollbar-button {\n      width: 0px;\n      height: 0px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-thumb:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-thumb:active {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track {\n      background: white;\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-track:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track:active {\n      background: ",
        ';\n    }\n    ::-webkit-scrollbar-corner {\n      background: transparent;\n    }\n\n    .hide {\n      display: none;\n    }\n\n    .stop-scrolling {\n      height: 100%;\n      overflow: hidden;\n    }\n\n    /* Hide crisp chat */\n    #crisp-chatbox > div > a {\n      display: none !important;\n\n      &[data-visible="true"] {\n        display: block !important;\n      }\n    }\n\n    /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    select {\n      appearance: none;\n      cursor: pointer;\n      padding-right : 20px;\n      min-width : 48px;\n      :focus {\n        outline: 0;\n      }\n      background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgMjU1IDI1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjU1IDI1NTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJhcnJvdy1kcm9wLWRvd24iPgoJCTxwb2x5Z29uIHBvaW50cz0iMCw2My43NSAxMjcuNSwxOTEuMjUgMjU1LDYzLjc1ICAgIiBmaWxsPSIjNmI2YjZiIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==")\n        calc(100% - 8px) center/8px auto no-repeat #fff !important;\n    }\n\n    .sysmsg-content {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 0;\n\n      & > div {\n        background: transparent;\n        padding: 0;\n      }\n\n      & > div > div > span {\n        & > .alert-green,\n        & > .alert-red,\n        & > .alert-blue,\n        & > .alert-orange {\n          border-radius: 5px;\n          padding: 10px 15px;\n        }\n      }\n\n      & > div > div > span > .alert-green {\n        background: #e1f6e5;\n        color: ',
        ";\n      }\n      \n      & > div > div > span > .alert-red {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-orange {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-blue {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      & > div > div > span > .snackbar-green {\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 13px 16px;\n        font-family: var(--font-bold);\n        background: #e1f6e5;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      & > div > div > span > .plain-green {\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        font-family: var(--font-regular);\n        background: ",
        ";\n        color: ",
        ";\n        line-height: 16.1px;\n      }\n    }\n\n    .modal-conversation {\n      z-index: 50 !important;\n      @media ",
        " {\n        z-index: 1000 !important;\n      }\n    }\n    \n    input:-webkit-autofill {\n      -webkit-box-shadow: 0 0 0 1000px #fff inset!important;\n      box-shadow: 0 0 0 1000px #fff inset!important;\n    }\n\n    .panel-avatar {\n      width: 30px;\n      height: 30px;\n      border: solid 1px #c0c0c0;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  \n    // FLOATING CHAT NOTIFICATION\n    .float-chat-notification {\n      min-height: 76px;\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    // FLOATIN ALERT NOTIFICATION\n    .float-alert-notification {\n      padding: 0;\n      border: 1px solid #dadada;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n\n      .ant-notification-notice-icon {\n        left: 0;\n        top: 0;\n        margin-left: 0;\n        height: 100%;\n        \n        img {\n          width: 100%;\n          height: 100%\n        }\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        font-family: var(--font-bold);\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-top: 15px;\n        margin-left: 85px;\n      }\n\n      & .ant-notification-notice-description {\n        padding-bottom: 15px;\n        margin-left: 85px;\n        line-height: normal;\n      }\n\n      & .ant-notification-notice-close {\n        top: 16px;\n        right: 16px;\n        font-size: 12px;\n      }\n    }\n\n    // FLOATIN GENERAL NOTIFICATION\n    .float-general-notification {\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        overflow: hidden;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    .reverse {\n      transform: rotate(180deg);\n    }\n\n    .button-unstyled {\n      background: transparent;\n      border: none;\n      cursor: pointer;\n\n      &.full-button {\n        display: block;\n        width: 100%;\n      }\n    }\n\n    /* FUNDACHART */\n    .fundachart-custom-tooltip {\n      height: 16px;\n      border: 1px solid #dadada;\n      position: absolute;\n      font-size: 11px;\n      display: flex;\n      align-items: center;\n      padding: 1px 5px 0 5px;\n      background-color: #FFF;\n    }\n\n    .fundachart-custom-tooltip:before {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(218, 218, 218, 0);\n      border-right-color: #dadada;\n      border-width: 9px;\n      margin-top: -9px;\n    }\n\n    .fundachart-custom-tooltip:after {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(255, 255, 255, 0);\n      border-right-color: #fff;\n      border-width: 8px;\n      margin-top: -8px;\n    }\n\n    .orderbook-text-cell {\n      color: #333333;\n      font-family: ProximaNovaRg;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      text-align: right;\n      padding: 8px 0px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n\n      &.frequency {\n        color: #8277F8;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n\n      &.title {\n        font-family: ProximaNovaBd;\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        line-height: 16px;\n        padding: 8px 0px;\n      }\n    }\n\n    .orderbook-text-summary {\n      color: #333333;\n      font-family: ProximaNovaBd;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      -webkit-font-smoothing: antialiased;\n      font-smoothing: antialiased;\n      line-height: 16px;\n      text-align: center;\n      padding: 8px 0px;\n\n      &.center {\n        text-align: center;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n    }\n\n    .orderbook-que-bid,\n    .orderbook-que-off {\n      position: relative;\n    }\n\n    .table-live-price {\n      font-size: 12px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      margin: 12px 8px;\n      table-layout: fixed;\n      width: calc(100% - calc(2 * 8px));\n\n      td {\n        padding: 4px 0px;\n        text-align: right;\n        white-space: nowrap;\n        color: #333333;\n\n        &.up {\n          color: #00ab6b;\n        }\n  \n        &.down {\n          color: #ee4a49;\n        }\n  \n        &.notchange {\n          color: #979134;\n        }\n      }\n\n      td:first-child {\n        padding-left: 0px;\n        text-align: left;\n      }\n\n      td:nth-child(3) {\n        text-align: left;\n      }\n\n      td:nth-child(5) {\n        text-align: left;\n      }\n\n      td:last-child {\n        padding-right: 0px;\n      }\n\n      tr:first-child {\n        td {\n          padding-top: 0px;\n        }\n      }\n\n      tr:last-child {\n        td {\n          padding-bottom: 0px;\n        }\n      }\n\n      td > div.item-clickable {\n        margin-right: -4px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n\n        :hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .orderbook-last-price {\n      font-size: 12.5px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 21px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    .intercom-unread-count {\n      backface-visibility: hidden;\n      background: #fc576b;\n      border-radius: 10px;\n      box-shadow: none;\n      box-sizing: border-box;\n      color: #fff;\n      font-size: 12px;\n      height: 20px;\n      line-height: 20px;\n      min-width: 20px;\n      opacity: 0;\n      padding: 0 4px;\n      position: absolute;\n      left: -5px;\n      text-align: center;\n      top: 5px;\n      transform: scale(0.5);\n      transform-origin: center;\n      transition: opacity 0.15s ease, transform 0.15s ease;\n      font-family: sans-serif;\n\n      @media screen and (max-width: 720px) {\n          left: 3px;\n      }\n      \n      &.active {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n\n    .price-cell {\n      width: max-content;\n      \n      &.min {\n        min-width: 135px;\n      }\n\n      &.mid {\n        min-width: 156px;\n      }\n\n      &.full {\n        min-width: max-content;\n      }\n    }\n\n    /* Modal Multi Portfolio */\n    .modal-multi-porto {\n      max-width: 410px;\n\n      &.withdraw {\n        max-width: 450px;\n      }\n    }\n\n    .modal-multi-porto.no-padding .ant-modal-body {\n      padding: 0;\n    }\n\n    .modal-multi-porto .ant-modal-body > h4 {\n      text-align: left;\n      padding-left: 20px;\n      font-size: 16px;\n    }\n\n    .modal-multi-porto .ant-btn-primary[disabled] {\n      background-color: #cceee1 !important;\n      color: #ffffff !important;\n      border: none;\n\n      &:hover > p {\n        color: #ffffff;\n      }\n    }\n\n    /* Override Antd Select Modal Multi Porto */\n    .modal-multi-porto-open {\n      .ant-select-dropdown {\n        padding: 0;\n\n        .ant-select-item-option {\n          min-height: 50px;\n          padding: 0 12px;\n        }\n\n        .ant-select-item-option:not(:last-child) {\n          // border-bottom: 1px solid red;\n        }\n\n        .ant-select-item-option:hover {\n          background-color: #F7F7F7;\n        }\n      }\n\n      .ant-select-dropdown div[aria-selected='true'] {\n        img.transfer-check-icon {\n          display: block;\n        }\n\n        .option-text span.main-text {\n          font-weight: 400 !important;\n          font-family: ProximaNovaRg !important;\n        }\n      }\n\n      .ant-select-item-option {\n        div.option-text .main-porto {\n          display: flex;\n        }\n      }\n\n      .ant-select-item-option-content {\n        border-top: 1px solid #EDEDED;\n      }\n\n      .ant-select-item-option:first-child .ant-select-item-option-content {\n        border-top: none;\n      }\n\n      .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n        background-color: #ffffff;\n      }\n\n      .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        background-color: #ffffff;\n        cursor: default;\n      }\n\n      .ant-select-disabled .ant-select-arrow {\n        display: none;\n      }\n    }\n\n    .modal-multi-porto.error {\n      .ant-modal-content {\n        border-radius: 10px;\n      }\n\n      .ant-modal-close-x {\n        margin-top: 0;\n      }\n    }\n    /* End Modal Multi Portfolio */\n\n    /* Modal Auto Order */\n    .modal-tnc-auto-order {\n      width: 520px !important;\n\n      .ant-btn-primary[disabled] {\n        background-color: #cceee1 !important;\n        color: #ffffff !important;\n        border: none;\n\n        &:hover > p {\n          color: #ffffff;\n        }\n      }\n\n      .ant-modal-content {\n        border-radius: 10px !important;\n      }\n\n      .ant-modal-body h4 {\n        font-size: 16px;\n        text-align: left;\n        padding-left: 20px;\n      }\n    }\n    /* End Modal Auto Order */\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var overideAntdCSS = (0,styled_components_browser_esm/* css */.iv)(GlobalStyles_templateObject(), color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, "".concat(color/* default.downgray */.Z.downgray).concat((0,hexOpacity/* default */.Z)(35)), color/* default.black */.Z.black + (0,hexOpacity/* default */.Z)(60), color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro);
var variables = (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject2(), overideAntdCSS, variables, color/* default.gainsboro */.Z.gainsboro, color/* default.aliceBlue */.Z.aliceBlue, color/* default.dimgray */.Z.dimgray, color/* default.dimgray */.Z.dimgray, color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, color/* default.black */.Z.black, color/* default.alertRed */.Z.alertRed, color/* default.black */.Z.black, color/* default.alertOrange */.Z.alertOrange, color/* default.black */.Z.black, color/* default.alertBlue */.Z.alertBlue, color/* default.black */.Z.black, color/* default.primary */.Z.primary, color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, GlobalStyles_alert/* default */.Z, tooltip, layout);
/* harmony default export */ var global_GlobalStyles = (GlobalStyles);

;// CONCATENATED MODULE: ./src/global/Scripts/TikTokPixel.js
/* eslint-disable react/no-danger */ 

var tiktokKey = "C5P9ESLODNNK397VS21G";
var TikTokPixel = function() {
    if (!tiktokKey) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: '\n            !function (w, d, t) {\n              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};\n            \n              ttq.load(\''.concat(tiktokKey, "');\n              ttq.page();\n            }(window, document, 'ttq');\n          ")
            }
        })
    });
};
/* harmony default export */ var Scripts_TikTokPixel = (TikTokPixel);

// EXTERNAL MODULE: ./src/global/SupportButton/index.tsx
var SupportButton = __webpack_require__(84468);
// EXTERNAL MODULE: ./src/global/Datafeed/index.tsx + 1 modules
var Datafeed = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/ping_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/ping.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.PingRequest
 */
const PingRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.PingRequest",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.PingResponse
 */
const PingResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.PingResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/auth_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/auth.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.AuthRequest
 */
const AuthRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.AuthResponse
 */
const AuthResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.AuthResponse",
  [],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm.proto (package securities.trm.core.smart_order.trailing_stop.order.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType
 */
const PriceAlgorithmType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType",
  [
    {no: 0, name: "PRICE_ALGORITHM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRICE_ALGORITHM_TYPE_TRAILING_STOP_PERCENTAGE", localName: "TRAILING_STOP_PERCENTAGE"},
  ],
);

/**
 * @generated from message securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm
 */
const PriceAlgorithm = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PriceAlgorithmType) },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/money_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/money.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents an amount of money with its currency type.
 *
 * @generated from message google.type.Money
 */
const Money = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Money",
  () => [
    { no: 1, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "units", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "nanos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/date_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/date.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message google.type.Date
 */
const date_pb_Date = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Date",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/entity/v2/portfolio_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/entity/v2/portfolio.proto (package securities.trm.core.portfolio.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * Side defines sides for an order
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.Side
 */
const Side = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIDE_BUY", localName: "BUY"},
    {no: 2, name: "SIDE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.PlatformOrderType
 */
const PlatformOrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.PlatformOrderType",
  [
    {no: 0, name: "PLATFORM_ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLATFORM_ORDER_TYPE_LIMIT_DAY", localName: "LIMIT_DAY"},
    {no: 2, name: "PLATFORM_ORDER_TYPE_MARKET_FAK", localName: "MARKET_FAK"},
    {no: 3, name: "PLATFORM_ORDER_TYPE_FAST_ORDER", localName: "FAST_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.LeverageType
 */
const LeverageType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.LeverageType",
  [
    {no: 0, name: "LEVERAGE_TYPE_TRADING_UNSPECIFIED", localName: "TRADING_UNSPECIFIED"},
    {no: 1, name: "LEVERAGE_TYPE_TRADING_BALANCE", localName: "TRADING_BALANCE"},
    {no: 2, name: "LEVERAGE_TYPE_TRADING_LIMIT", localName: "TRADING_LIMIT"},
    {no: 3, name: "LEVERAGE_TYPE_BASIC_LIMIT", localName: "BASIC_LIMIT"},
    {no: 4, name: "LEVERAGE_TYPE_TEMP_LIMIT", localName: "TEMP_LIMIT"},
    {no: 5, name: "LEVERAGE_TYPE_DAY_TRADE", localName: "DAY_TRADE"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.SecuritiesKind
 */
const SecuritiesKind = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SecuritiesKind",
  [
    {no: 0, name: "SECURITIES_KIND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SECURITIES_KIND_STOCK", localName: "STOCK"},
    {no: 2, name: "SECURITIES_KIND_BOND", localName: "BOND"},
  ],
);

/**
 * PortfolioListSummary contains summary of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary
 */
const PortfolioSummary = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary",
  () => [
    { no: 1, name: "trading", kind: "message", T: PortfolioSummary_Trading },
    { no: 2, name: "amount", kind: "message", T: PortfolioSummary_Amount },
    { no: 3, name: "profit_loss", kind: "message", T: PortfolioSummary_ProfitLoss },
    { no: 4, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "equity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "debt", kind: "message", T: PortfolioSummary_Debt },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading
 */
const PortfolioSummary_Trading = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading",
  () => [
    { no: 1, name: "balance", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Trading"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount
 */
const PortfolioSummary_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "allocated", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "credit_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss
 */
const PortfolioSummary_ProfitLoss = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss",
  () => [
    { no: 1, name: "net", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "unrealised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "realised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_ProfitLoss"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt
 */
const PortfolioSummary_Debt = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt",
  () => [
    { no: 1, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Debt"},
);

/**
 * PortfolioPrice contains price information in portfolio for one symbol
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice
 */
const PortfolioPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice",
  () => [
    { no: 1, name: "latest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: PortfolioPrice_Average },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average
 */
const PortfolioPrice_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioPrice_Average"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty
 */
const PortfolioQty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty",
  () => [
    { no: 1, name: "stock_on_hand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available", kind: "message", T: PortfolioQty_Qty },
    { no: 3, name: "balance", kind: "message", T: PortfolioQty_Qty },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty
 */
const PortfolioQty_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty",
  () => [
    { no: 1, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioQty_Qty"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset
 */
const PortfolioAsset = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset",
  () => [
    { no: 1, name: "unrealised", kind: "message", T: PortfolioAsset_Unrealised },
    { no: 2, name: "amount_invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised
 */
const PortfolioAsset_Unrealised = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised",
  () => [
    { no: 1, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "profit_loss", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioAsset_Unrealised"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioFlags
 */
const PortfolioFlags = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioFlags",
  () => [
    { no: 1, name: "allow_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "have_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_buy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_sell", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Order defines information on a single order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order
 */
const Order = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: Order_Time },
    { no: 8, name: "qty", kind: "message", T: Order_Qty },
    { no: 9, name: "price", kind: "message", T: Order_Price },
    { no: 10, name: "amount", kind: "message", T: Order_Amount },
    { no: 11, name: "action", kind: "message", T: Order_Action },
    { no: 12, name: "smart_order", kind: "message", T: Order_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: Order_GTC },
    { no: 14, name: "day_trade", kind: "message", T: Order_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "securities_kind", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SecuritiesKind) },
    { no: 18, name: "platform_order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlatformOrderType) },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell
 */
const Order_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount
 */
const Order_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: Order_Amount_Fee },
  ],
  {localName: "Order_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee
 */
const Order_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: Order_Amount_Fee_Matched },
  ],
  {localName: "Order_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched
 */
const Order_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price
 */
const Order_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: Order_Price_Average },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price.Average
 */
const Order_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Time
 */
const Order_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Time",
  () => [
    { no: 1, name: "order", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "open", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "match", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "Order_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Action
 */
const Order_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Order_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder
 */
const Order_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "trailing_stop", kind: "message", T: Order_SmartOrder_TrailingStop },
  ],
  {localName: "Order_SmartOrder"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop
 */
const Order_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "Order_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.GTC
 */
const Order_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_GTC_GTCStatus) },
  ],
  {localName: "Order_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus
 */
const Order_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Qty
 */
const Order_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.DayTrade
 */
const Order_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_DayTradeForceSell) },
  ],
  {localName: "Order_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail
 */
const OrderDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: OrderDetail_Time },
    { no: 8, name: "qty", kind: "message", T: OrderDetail_Qty },
    { no: 9, name: "price", kind: "message", T: OrderDetail_Price },
    { no: 10, name: "amount", kind: "message", T: OrderDetail_Amount },
    { no: 11, name: "action", kind: "message", T: OrderDetail_Action },
    { no: 12, name: "smart_order", kind: "message", T: OrderDetail_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: OrderDetail_GTC },
    { no: 14, name: "day_trade", kind: "message", T: OrderDetail_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
  ],
)));

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell
 */
const OrderDetail_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount
 */
const OrderDetail_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: OrderDetail_Amount_Fee },
  ],
  {localName: "OrderDetail_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee
 */
const OrderDetail_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: OrderDetail_Amount_Fee_Matched },
  ],
  {localName: "OrderDetail_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched
 */
const OrderDetail_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price
 */
const OrderDetail_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: OrderDetail_Price_Average },
  ],
  {localName: "OrderDetail_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average
 */
const OrderDetail_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "portfolio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Time
 */
const OrderDetail_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Time",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "opened_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "matched_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "OrderDetail_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Action
 */
const OrderDetail_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "OrderDetail_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder
 */
const OrderDetail_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_SmartOrder_ConfigPriceType) },
    { no: 5, name: "trailing_stop", kind: "message", T: OrderDetail_SmartOrder_TrailingStop },
  ],
  {localName: "OrderDetail_SmartOrder"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType
 */
const OrderDetail_SmartOrder_ConfigPriceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType",
  [
    {no: 0, name: "CONFIG_PRICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIG_PRICE_TYPE_ABOVE", localName: "ABOVE"},
    {no: 2, name: "CONFIG_PRICE_TYPE_BELOW", localName: "BELOW"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop
 */
const OrderDetail_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "OrderDetail_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.GTC
 */
const OrderDetail_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_GTC_GTCStatus) },
  ],
  {localName: "OrderDetail_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus
 */
const OrderDetail_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Qty
 */
const OrderDetail_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade
 */
const OrderDetail_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_DayTradeForceSell) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "OrderDetail_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Company
 */
const Company = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Company",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData
 */
const ExerciseData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "date", kind: "message", T: ExerciseData_Date },
    { no: 9, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData.Date
 */
const ExerciseData_Date = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData.Date",
  () => [
    { no: 1, name: "listing", kind: "message", T: date_pb_Date },
    { no: 2, name: "expired", kind: "message", T: date_pb_Date },
    { no: 3, name: "mature", kind: "message", T: date_pb_Date },
    { no: 4, name: "start", kind: "message", T: date_pb_Date },
    { no: 5, name: "end", kind: "message", T: date_pb_Date },
  ],
  {localName: "ExerciseData_Date"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioItem
 */
const PortfolioItem = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioItem",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail
 */
const PortfolioDetail = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "bond", kind: "message", T: PortfolioDetail_Bond },
    { no: 9, name: "can_create_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond
 */
const PortfolioDetail_Bond = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond",
  () => [
    { no: 1, name: "coupon", kind: "message", T: PortfolioDetail_Bond_Coupon },
    { no: 2, name: "maturity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon
 */
const PortfolioDetail_Bond_Coupon = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon",
  () => [
    { no: 1, name: "year_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond_Coupon"},
);

/**
 * PortfolioList defines data on response PortfolioListResponse
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList
 */
const PortfolioList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList",
  () => [
    { no: 1, name: "smart_order_info", kind: "message", T: PortfolioList_SmartOrderInfo },
    { no: 2, name: "summary", kind: "message", T: PortfolioSummary },
    { no: 3, name: "results", kind: "message", T: PortfolioItem, repeated: true },
    { no: 4, name: "day_trade", kind: "message", T: PortfolioItem, repeated: true },
  ],
);

/**
 * PortfolioListInfo contains info of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo
 */
const PortfolioList_SmartOrderInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo",
  () => [
    { no: 1, name: "can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "day_trade_can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "PortfolioList_SmartOrderInfo"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/wsevent/v1/securities_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/wsevent/v1/securities.proto (package securities.trm.core.portfolio.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * WebsocketResponse defines messages when sending response to websocket client
 *
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse
 */
const WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "action", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketResponse_Action) },
    { no: 2, name: "portfolio_summary", kind: "message", T: PortfolioSummary, oneof: "message" },
    { no: 3, name: "portfolio_detail", kind: "message", T: PortfolioDetail, oneof: "message" },
    { no: 4, name: "portfolio_list", kind: "message", T: PortfolioList, oneof: "message" },
    { no: 5, name: "order_detail", kind: "message", T: Order, oneof: "message" },
    { no: 6, name: "order_list", kind: "message", T: WebsocketResponse_OrderList, oneof: "message" },
    { no: 7, name: "portfolio_detail_day_trade", kind: "message", T: PortfolioDetail, oneof: "message" },
  ],
);

/**
 * Action provides various action can applied to websocket message
 *
 * @generated from enum securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action
 */
const WebsocketResponse_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_UPSERT", localName: "UPSERT"},
    {no: 2, name: "ACTION_DELETE", localName: "DELETE"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList
 */
const WebsocketResponse_OrderList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList",
  () => [
    { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
  ],
  {localName: "WebsocketResponse_OrderList"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/websocket.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * WebsocketRequest handles request for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest
 */
const WebsocketRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: WebsocketRequest_Request, repeated: true },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest.Request
 */
const WebsocketRequest_Request = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "command", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Command), oneof: "action" },
    { no: 3, name: "subscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
    { no: 4, name: "unsubscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
  ],
  {localName: "WebsocketRequest_Request"},
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Command
 */
const WebsocketRequest_Request_Command = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_PING", localName: "PING"},
    {no: 2, name: "COMMAND_AUTH", localName: "AUTH"},
  ],
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel
 */
const WebsocketRequest_Request_Channel = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel",
  [
    {no: 0, name: "CHANNEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHANNEL_SECURITIES_LIVE_PORTO", localName: "SECURITIES_LIVE_PORTO"},
  ],
);

/**
 * WebsocketResponse handles response for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketResponse
 */
const websocket_pb_WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "response" },
    { no: 3, name: "auth", kind: "message", T: AuthResponse, oneof: "response" },
    { no: 4, name: "securities", kind: "message", T: WebsocketResponse, oneof: "response" },
  ],
);


// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.tsx
var securities_store = __webpack_require__(28840);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useUnauthorized.ts



function useUnauthorized(handleLogoutSecurities) {
    var checkUnauthorized = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(URL, token) {
            var httpsUrl, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        httpsUrl = URL.replace("wss://", "https://");
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetch(httpsUrl, {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 10;
                            break;
                        }
                        if (!(response.status === constants/* ERROR_CODE.UNAUTHORIZED */.Bq.UNAUTHORIZED)) {
                            _ctx.next = 9;
                            break;
                        }
                        handleLogoutSecurities === null || handleLogoutSecurities === void 0 ? void 0 : handleLogoutSecurities();
                        return _ctx.abrupt("return", true);
                    case 9:
                        throw new Error(response.statusText);
                    case 10:
                        return _ctx.abrupt("return", false);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function checkUnauthorized(URL, token) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        checkUnauthorized: checkUnauthorized
    };
};

// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/SecuritiesProvider.tsx
/* eslint-disable @typescript-eslint/no-use-before-define */ 













var WS_URL = "wss://ws-gen.stockbit.com/v1";
var SecuritiesProvider = function(props) {
    var ref;
    var children = props.children, isLoggedIn = props.isLoggedIn, _heartbeatInterval = props.heartbeatInterval, heartbeatInterval = _heartbeatInterval === void 0 ? constants/* HEARTBEAT_INTERVAL */.al : _heartbeatInterval, handleLogoutSecurities = props.handleLogoutSecurities;
    var socketRef = (0,react.useRef)();
    var lastPing = (0,react.useRef)(Date.now());
    var lastPong = (0,react.useRef)(Date.now());
    var actionsRef = (0,react.useRef)({});
    var isLoggedInRef = (0,react.useRef)(false);
    var wsIsConnectingRef = (0,react.useRef)(false);
    var reconnectCounterRef = (0,react.useRef)(1);
    var unauthorizedCounterRef = (0,react.useRef)(1);
    var reconnectTimeoutRef = (0,react.useRef)();
    var pingTimeoutRef = (0,react.useRef)();
    var healthCheckInterval = (0,react.useRef)();
    var ref1 = (0,react.useState)(), authToken = ref1[0], setAuthToken = ref1[1];
    var ref2 = (0,react.useState)(constants/* ReadyState.UNINSTANTIATED */.kQ.UNINSTANTIATED), readyState = ref2[0], setReadyState = ref2[1];
    var ref3 = (0,react.useState)(constants/* NetworkStatus.ONLINE */.Ie.ONLINE), networkStatus = ref3[0], setNetworkStatus = ref3[1];
    var ref4 = (0,securities_store/* useSecuritiesStore */.$A)(function(state) {
        return {
            channel: state.channel,
            isReconnectionFailed: state.isReconnectionFailed,
            setChannel: state.setChannel,
            resetChannel: state.resetChannel,
            setIsReconnectionFailed: state.setIsReconnectionFailed,
            setIsSocketOnline: state.setIsSocketOnline
        };
    }), channel = ref4.channel, isReconnectionFailed = ref4.isReconnectionFailed, setChannel = ref4.setChannel, resetChannel = ref4.resetChannel, setIsReconnectionFailed = ref4.setIsReconnectionFailed, setIsSocketOnline = ref4.setIsSocketOnline;
    var checkUnauthorized = useUnauthorized(handleLogoutSecurities).checkUnauthorized;
    var setCookie = (0,react.useCallback)(function(value) {
        if ((0,app/* isClient */.C5)()) {
            document.cookie = (0,utils/* generateWSCookie */.y_)(value);
        }
    }, []);
    var setAction = function(channelKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            draft[channelKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (draft === null || draft === void 0 ? void 0 : draft[channelKey]) {
                delete draft[channelKey];
            }
        });
    };
    var isWebsocketNotReady = (0,react.useCallback)(function() {
        var socket = socketRef.current;
        // If no socket instance or WebSocket isn't open or still connecting
        return !socket || socket.readyState !== WebSocket.OPEN;
    }, [
        (ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState
    ]);
    var getSecuritiesAccessToken = (0,react.useCallback)(function() {
        if ((0,app/* isClient */.C5)()) {
            var securitiesToken = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken();
            return securitiesToken.securitiesAccessToken;
        }
        return undefined;
    }, []);
    var sendPingHeartbeat = (0,react.useCallback)(function() {
        if (isWebsocketNotReady()) return;
        var pingRequest = (0,utils/* createPingPayload */.c$)();
        var bufferPing = new WebsocketRequest({
            requests: [
                pingRequest
            ]
        }).toBinary();
        socketRef.current.send(bufferPing);
        lastPing.current = Date.now();
    }, []);
    var combinedChannel = (0,react.useMemo)(function() {
        var resultArray = Object.values(channel);
        return resultArray;
    }, [
        channel
    ]);
    var sendMessageChannel = (0,react.useCallback)(function(channelRequests) {
        if (isWebsocketNotReady() || channelRequests.length === 0) {
            return;
        }
        var buffer = new WebsocketRequest({
            requests: channelRequests
        }).toBinary();
        socketRef.current.send(buffer);
        // remove channel that has been unsubscribed
        var isUnsubscribed = channelRequests.some(function(channelRequest) {
            var ref;
            return (channelRequest === null || channelRequest === void 0 ? void 0 : (ref = channelRequest.action) === null || ref === void 0 ? void 0 : ref.case) === "unsubscribe";
        });
        if (isUnsubscribed) {
            resetChannel();
        }
    }, []);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var handleMessage = (0,react.useCallback)(function(message) {
        var dataRaw = websocket_pb_WebsocketResponse.fromBinary(new Uint8Array(message.data));
        var response = dataRaw.response;
        var messageCase = response.case, value = response.value;
        if (messageCase === "ping") {
            lastPong.current = Date.now();
        }
        var channelAction = actionsRef.current[messageCase];
        if (channelAction) {
            channelAction(value);
        }
    }, []);
    var handleHeartbeatMessage = function() {
        pingTimeoutRef.current = setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatInterval);
    };
    var handleOpen = function() {
        if (!socketRef.current) return;
        setAction("ping", handleHeartbeatMessage);
        sendPingHeartbeat();
        setIsSocketOnline(true);
        setReadyState(constants/* ReadyState.OPEN */.kQ.OPEN);
        socketRef.current.addEventListener("message", handleMessage);
        // Reset all reconnection state
        reconnectCounterRef.current = 1;
        setIsReconnectionFailed(false);
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = undefined;
        }
    };
    var handleReconnectionFailed = (0,react.useCallback)(function() {
        if (networkStatus === constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE || reconnectCounterRef.current > constants/* MAX_POLLING_ATTEMPTS */.LU) {
            return;
        }
        reconnectTimeoutRef.current = setTimeout(function() {
            restartSocket();
        }, constants/* RECONNECT_INTERVAL */.aG);
    }, [
        networkStatus
    ]);
    var handleClose = function() {
        setIsSocketOnline(false);
        setReadyState(constants/* ReadyState.CLOSED */.kQ.CLOSED);
        if (!isLoggedInRef.current) return;
        if (reconnectCounterRef.current <= constants/* MAX_RECONNECT_ATTEMPTS */.pm) {
            restartSocket();
            reconnectCounterRef.current += 1;
            return;
        }
        setIsReconnectionFailed(true);
        handleReconnectionFailed();
        reconnectCounterRef.current += 1;
    };
    var handleError = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var token, isUnauthorized;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSocketOnline(false);
                        setReadyState(constants/* ReadyState.CLOSED */.kQ.CLOSED);
                        token = getSecuritiesAccessToken();
                        isUnauthorized = false;
                        if (!(token && networkStatus === constants/* NetworkStatus.ONLINE */.Ie.ONLINE && unauthorizedCounterRef.current <= constants/* MAX_RECONNECT_ATTEMPTS */.pm)) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return checkUnauthorized(WS_URL, token);
                    case 7:
                        isUnauthorized = _ctx.sent;
                        unauthorizedCounterRef.current += 1;
                    case 9:
                        if (isUnauthorized) {
                            resetSocket();
                            resetState();
                            isLoggedInRef.current = false;
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleError() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSocket = (0,react.useCallback)(function() {
        if (!isLoggedInRef.current || networkStatus === constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE || readyState === constants/* ReadyState.OPEN */.kQ.OPEN || wsIsConnectingRef.current && isReconnectionFailed) {
            return;
        }
        setAuthToken(undefined);
        var key = getSecuritiesAccessToken();
        if (!key || !WS_URL) return;
        setAuthToken(key);
        setCookie(key);
        wsIsConnectingRef.current = true;
        socketRef.current = new WebSocket(WS_URL);
        socketRef.current.binaryType = "arraybuffer";
        // @ts-ignore
        window.securitiesSocket = socketRef.current;
        socketRef.current.addEventListener("open", handleOpen, {
            once: true
        });
        socketRef.current.addEventListener("close", handleClose, {
            once: true
        });
        socketRef.current.addEventListener("error", handleError, {
            once: true
        });
        setTimeout(function() {
            wsIsConnectingRef.current = false;
        }, constants/* UPTIME */.Dp);
    }, [
        networkStatus,
        readyState,
        wsIsConnectingRef.current,
        isReconnectionFailed,
        handleOpen,
        handleClose,
        handleError, 
    ]);
    var resetTimeout = (0,react.useCallback)(function() {
        if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = undefined;
        }
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = undefined;
        }
        if (healthCheckInterval.current) {
            clearInterval(healthCheckInterval.current);
            healthCheckInterval.current = undefined;
        }
    }, [
        pingTimeoutRef,
        reconnectTimeoutRef,
        healthCheckInterval
    ]);
    var resetSocket = (0,react.useCallback)(function() {
        var ref;
        if (!socketRef.current) return;
        if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === WebSocket.OPEN) {
            socketRef.current.close();
        }
        socketRef.current = undefined;
        setAuthToken(undefined);
        removeAction("ping");
        resetTimeout();
    }, [
        setAuthToken,
        removeAction,
        resetTimeout
    ]);
    var restartSocket = (0,react.useCallback)(function() {
        if (!isLoggedInRef.current) return;
        resetSocket();
        initSocket();
    }, [
        resetSocket,
        initSocket
    ]);
    var resetState = (0,react.useCallback)(function() {
        setIsReconnectionFailed(false);
        setAuthToken(undefined);
        setCookie(undefined);
        setReadyState(constants/* ReadyState.UNINSTANTIATED */.kQ.UNINSTANTIATED);
        if (isLoggedInRef.current) {
            resetChannel();
            isLoggedInRef.current = false;
        }
        socketRef.current = undefined;
        reconnectCounterRef.current = 1;
        unauthorizedCounterRef.current = 1;
        resetTimeout();
    }, [
        setIsReconnectionFailed,
        setAuthToken,
        setCookie,
        isLoggedInRef,
        reconnectCounterRef,
        unauthorizedCounterRef,
        resetTimeout, 
    ]);
    var handleSocket = (0,react.useCallback)(function(isLogin) {
        if (!socketRef.current && isLogin) {
            restartSocket();
        } else if (socketRef.current && !isLogin) {
            resetSocket();
        }
        if (!isLogin) {
            resetState();
        }
    }, [
        restartSocket,
        resetSocket,
        resetState
    ]);
    // Handle Send Channel
    (0,react.useEffect)(function() {
        if (authToken && combinedChannel) {
            handleSendChannel(combinedChannel);
        }
    }, [
        authToken,
        combinedChannel,
        handleSendChannel
    ]);
    // Handle Socket Connection
    (0,react.useEffect)(function() {
        isLoggedInRef.current = isLoggedIn;
        var timeout = setTimeout(function() {
            handleSocket(isLoggedIn);
        }, 300);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isLoggedIn,
        handleSocket
    ]);
    // Handle Online Offline Connection
    (0,react.useEffect)(function() {
        var handleOnline = function() {
            var ref;
            setNetworkStatus(constants/* NetworkStatus.ONLINE */.Ie.ONLINE);
            if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === constants/* ReadyState.CLOSED */.kQ.CLOSED || readyState === constants/* ReadyState.CLOSED */.kQ.CLOSED) {
                restartSocket();
            }
        };
        var handleOffline = function() {
            var ref;
            setNetworkStatus(constants/* NetworkStatus.OFFLINE */.Ie.OFFLINE);
            if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === constants/* ReadyState.OPEN */.kQ.OPEN) {
                resetSocket();
            }
        };
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return function() {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    // Handle Reconnect Interval
    (0,react.useEffect)(function() {
        if (readyState !== constants/* ReadyState.OPEN */.kQ.OPEN) return undefined;
        healthCheckInterval.current = setInterval(function() {
            var intervalPingPong = lastPing.current - lastPong.current;
            // Check if connection is unhealthy
            if (networkStatus === constants/* NetworkStatus.ONLINE */.Ie.ONLINE && intervalPingPong > heartbeatInterval * constants/* HEARTBEAT_FACTOR */.Nl) {
                restartSocket();
            }
        }, heartbeatInterval / 2);
        return function() {
            clearInterval(healthCheckInterval.current);
        };
    }, [
        restartSocket
    ]);
    var contextValue = (0,react.useMemo)(function() {
        return {
            isAuthorized: !!authToken,
            token: authToken,
            socket: socketRef.current,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction
        };
    }, [
        authToken,
        socketRef,
        setChannel,
        setAction,
        removeAction
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecuritiesContext/* SecuritiesContext.Provider */.i.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ var websocket_SecuritiesProvider = (SecuritiesProvider);

// EXTERNAL MODULE: ./src/utils/clevertap.js
var utils_clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/hooks/useClevertap.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 




function useClevertap() {
    var clevertapRef = (0,react.useRef)();
    var initClevertap = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var clevertap;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 45707).then(__webpack_require__.t.bind(__webpack_require__, 88739, 23));
                case 2:
                    clevertap = _ctx.sent.default;
                    clevertap.privacy.push({
                        optOut: false
                    });
                    clevertap.privacy.push({
                        useIP: false
                    });
                    clevertap.init(app/* CLEVERTAP_ID */.d7, "sg1");
                    clevertap.setLogLevel(3);
                    window.clevertap = clevertap;
                    (0,utils_clevertap/* clevertapInitProfileQueue */.QU)();
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    (0,react.useEffect)(function() {
        if (!clevertapRef.current) {
            initClevertap();
        }
    }, [
        clevertapRef.current,
        initClevertap
    ]);
    return null;
}
/* harmony default export */ var hooks_useClevertap = (useClevertap);

// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/global/WebSocketV2/index.ts
var WebSocketV2 = __webpack_require__(36784);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
;// CONCATENATED MODULE: ./src/hooks/useWebSocketSocialV2.ts





function useWebSocketSocialV2(param) {
    var isLoggedIn = param.isLoggedIn;
    var ref = (0,react.useState)(), webSocketSocialV2 = ref[0], setWebSocketSocialV2Connection = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var createSocialSocket = function() {
        return (0,slice/* getWskey */.fh)().then(function(wskey) {
            if (wskey !== null) {
                setWebSocketSocialV2Connection((0,WebSocketV2/* initWebsocketSocialV2 */.JC)(constant/* socketV2Key.social */.Iv.social, wskey));
            }
        });
    };
    (0,react.useEffect)(function() {
        if (!isLoggedIn) return;
        if (!webSocketSocialV2) {
            createSocialSocket();
        }
        dispatch(slice/* effects.initWebsocketSocialV2 */.Sz.initWebsocketSocialV2({
            webSocketSocialV2: webSocketSocialV2,
            createSocialSocket: createSocialSocket
        }));
    }, [
        webSocketSocialV2,
        isLoggedIn
    ]);
    return webSocketSocialV2;
}
/* harmony default export */ var hooks_useWebSocketSocialV2 = (useWebSocketSocialV2);

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/global/WebSocket/index.ts
var SOCKET_URL = "https://ws3.stockbit.com/";
function initPrimus() {
    var server = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SOCKET_URL;
    // @ts-ignore
    if ( false || typeof window.Primus === "undefined") {
        return null;
    }
    // @ts-ignore
    var primus = window.Primus(server, {
        strategy: false
    });
    // @ts-ignore
    window.primus = primus;
    return primus;
}
/* harmony default export */ var global_WebSocket = (initPrimus);

// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var WebSocket_slice = __webpack_require__(23985);
;// CONCATENATED MODULE: ./src/hooks/useWebSocket.ts


// WebSocket



/**
 * @summary open websocket connection
 * @param {Object} primus - primus object
 * @returns {[*, () => void]}
 */ function useWebSocket(scriptLoaded) {
    var ref = (0,react.useState)(null), ws = ref[0], setWs = ref[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var dispatch = (0,es/* useDispatch */.I0)();
    var clearPriceAlert = function() {
        dispatch(WebSocket_slice/* default.actions.clearAlert */.ZP.actions.clearAlert());
        localStorage.removeItem("price-alert");
    };
    (0,react.useEffect)(function() {
        if (!scriptLoaded) {
            return;
        }
        if (isLoggedIn) {
            var primus = global_WebSocket();
            setWs(primus);
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initWebsocket */.Sz.initWebsocket(primus));
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initListenData */.Sz.initListenData(primus));
        } else {
            clearPriceAlert();
            ws === null || ws === void 0 ? void 0 : ws.end();
        }
    }, [
        isLoggedIn,
        scriptLoaded
    ]);
    return ws;
}
/* harmony default export */ var hooks_useWebSocket = (useWebSocket);

;// CONCATENATED MODULE: ./src/global/Scripts/primus.tsx





var Primus = function() {
    var ref = (0,react.useState)(false), scriptLoaded = ref[0], setScriptLoaded = ref[1];
    hooks_useWebSocket(scriptLoaded);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        src: "".concat(app/* assetPrefix */.Vc, "/js/primus.min.js"),
        async: true,
        onLoad: function() {
            return setScriptLoaded(true);
        }
    });
};
/* harmony default export */ var primus = (Primus);

;// CONCATENATED MODULE: ./src/global/Scripts/firebase.tsx


var Firebase = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-app.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-analytics.js"
            })
        ]
    });
};
/* harmony default export */ var firebase = (Firebase);

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/crisp-sdk-web/dist/crisp.esm.js
var crisp_esm = __webpack_require__(36661);
;// CONCATENATED MODULE: ./src/hooks/useCrisp.ts











function useCrisp() {
    var ref;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var dataProfile = (0,es/* useSelector */.v9)(profile/* profileSelector */.Rd);
    // @ts-ignore
    var supportId = dataProfile === null || dataProfile === void 0 ? void 0 : (ref = dataProfile.support) === null || ref === void 0 ? void 0 : ref.id;
    (0,react.useEffect)(function() {
        crisp_esm/* Crisp.configure */.fv.configure(app/* CRISP_ID */.t0, {
            safeMode: true
        });
        var crispData = localStorage.getItem("crisp");
        if (crispData) {
            var crispDecoded = (0,general/* decodeBase64ToJS */.OB)(crispData);
            // @ts-ignore
            if (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.id) {
                // @ts-ignore
                crisp_esm/* Crisp.setTokenId */.fv.setTokenId(crispDecoded.id);
            }
        }
        // configuration on crisp load
        if (isLoggedIn) {
            (0,crisp/* onLoaded */.l4)();
        }
        // configuration on open
        (0,crisp/* onOpen */.zp)();
        // configuration on receive message
        (0,crisp/* onReceiveMessage */.Dj)();
    }, []);
    (0,react.useEffect)(function() {
        try {
            if ((0,app/* isClient */.C5)() && isLoggedIn) {
                var crispData = localStorage.getItem("crisp");
                // @ts-ignore
                var ref = auth/* default.getUserAccess */.Z.getUserAccess(), email = ref.email, avatar = ref.avatar, username = ref.username;
                if (supportId) {
                    crisp_esm/* Crisp.setTokenId */.fv.setTokenId(supportId);
                }
                var data = {
                    email: email,
                    avatar: avatar,
                    username: username
                };
                if (crispData) {
                    var crispDecoded = (0,general/* decodeBase64ToJS */.OB)(crispData);
                    // @ts-ignore
                    var phone = (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.phone) || (dataProfile === null || dataProfile === void 0 ? void 0 : dataProfile.phone);
                    if (phone) {
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            phone: phone
                        });
                    }
                }
                (0,crisp/* setNewSession */.kG)(data);
                localStorage.removeItem("crisp_visitor");
            }
        } catch (err) {
            ;
        }
    }, [
        isLoggedIn,
        supportId
    ]);
}
/* harmony default export */ var hooks_useCrisp = (useCrisp);

;// CONCATENATED MODULE: ./src/typings/platform.ts
var Platform;
(function(Platform) {
    Platform["Unspecified"] = "unspecified";
    Platform["Web"] = "web";
    Platform["Desktop"] = "desktop";
})(Platform || (Platform = {}));

;// CONCATENATED MODULE: ./src/hooks/useSharedWindowData.ts



/** Shares non-confidential data to the window object for Nx module federation */ var useSharedWindowData = function() {
    (0,react.useEffect)(function() {
        window.webSharedData = {
            projectFolder: app/* PROJECT_FOLDER */.sP,
            platform: Platform.Web
        };
    }, []);
};
/* harmony default export */ var hooks_useSharedWindowData = (useSharedWindowData);

// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var OrderTable_store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/global/MainApp/index.tsx
/* eslint-disable wrap-iife */ 


/* eslint-disable no-undef */ 



// store




// configs

// styles

// scripts

// components



// hooks
















var MainApp_queryClient = new queryClient/* QueryClient */.S({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
function MainApp(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var routerPath = router.asPath;
    var dispatch = (0,es/* useDispatch */.I0)();
    hooks_useSharedWindowData(); // Used for Nx module federation
    hooks_useCrisp();
    hooks_useClevertap();
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var setFliptUserId = (0,useFliptStore/* default */.Z)(function(s) {
        return s.setUserId;
    });
    var au = auth/* default.getUserAccess */.Z.getUserAccess();
    var tradingType = (0,useTradingAccount/* default */.Z)().tradingType;
    hooks_useWebSocketSocialV2({
        isLoggedIn: isLoggedIn
    });
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var isSecuritiesStaticPage = router.asPath.includes("/securities/static");
    var hideSupportButton = isSecuritiesStaticPage;
    var isFundachartPage = false;
    var renderPrimusScript = !isFundachartPage;
    var isScriptShouldShow = [
        isFundachartPage
    ].every(function(item) {
        return !item;
    });
    // Reset minimized header when route changes
    (0,react.useEffect)(function() {
        // @ts-ignore
        dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
    }, [
        routerPath
    ]);
    (0,react.useEffect)(function() {
        (0,logger/* sentrySetUser */.Kp)(isLoggedIn);
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        setFliptUserId(au === null || au === void 0 ? void 0 : au.id);
    }, [
        au === null || au === void 0 ? void 0 : au.id
    ]);
    var handleLogoutSecurities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isSecuritiesPage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        isSecuritiesPage = /securities\/.+/i.test(router.asPath);
                        if (!isSecuritiesPage) {
                            _ctx.next = 8;
                            break;
                        }
                        OrderTable_store/* default.getState */.Z.getState().resetOrderTableStore();
                        resetUIValue(typings_auth/* LoginType.Securities */.B.Securities);
                        _ctx.next = 8;
                        return router.push("/stream");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogoutSecurities() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(google, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts_TikTokPixel, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !hideSupportButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportButton/* default */.Z, {
                    isLoggedIn: isLoggedIn
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: renderPrimusScript,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primus, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(firebase, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
                client: MainApp_queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Datafeed/* DatafeedProvider */.l, {
                    isLoggedIn: isLoggedIn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(websocket_SecuritiesProvider, {
                        isLoggedIn: isLoggedIn && !!tradingType,
                        handleLogoutSecurities: handleLogoutSecurities,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                            theme: theme/* default */.ZP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_GlobalStyles, {}),
                                children
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_MainApp = (store/* wrapper.withRedux */.YS.withRedux(MainApp));


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSecuritiesContext; },
/* harmony export */   "i": function() { return /* binding */ SecuritiesContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SecuritiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isAuthorized: false,
    token: undefined,
    socket: undefined,
    setChannel: function() {},
    setAction: function() {},
    removeAction: function() {}
});
var useSecuritiesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SecuritiesContext);
    if (context === undefined) {
        throw new Error("useSecuritiesContext must be used within a SecuritiesProvider");
    }
    return context;
};



/***/ }),

/***/ 93313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "Dp": function() { return /* binding */ UPTIME; },
/* harmony export */   "FJ": function() { return /* binding */ SecuritiesMessageCase; },
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "LU": function() { return /* binding */ MAX_POLLING_ATTEMPTS; },
/* harmony export */   "Nl": function() { return /* binding */ HEARTBEAT_FACTOR; },
/* harmony export */   "S0": function() { return /* binding */ DATA_ACTION; },
/* harmony export */   "aG": function() { return /* binding */ RECONNECT_INTERVAL; },
/* harmony export */   "al": function() { return /* binding */ HEARTBEAT_INTERVAL; },
/* harmony export */   "kQ": function() { return /* binding */ ReadyState; },
/* harmony export */   "pm": function() { return /* binding */ MAX_RECONNECT_ATTEMPTS; }
/* harmony export */ });
var RECONNECT_INTERVAL = 30000; // 30 seconds
var HEARTBEAT_INTERVAL = 15000; // 15 seconds
var HEARTBEAT_FACTOR = 1.5; // 1.5 times the heartbeat interval
var MAX_RECONNECT_ATTEMPTS = 3;
var MAX_POLLING_ATTEMPTS = 50;
var UPTIME = 2000; // 2 seconds
var SecuritiesMessageCase = {
    SUMMARY: "portfolioSummary",
    PORTFOLIO_LIST: "portfolioList",
    PORTFOLIO_DETAIL: "portfolioDetail",
    PORTFOLIO_DETAIL_DAY_TRADE: "portfolioDetailDayTrade",
    ORDER_LIST: "orderList",
    ORDER_DETAIL: "orderDetail"
};
var DATA_ACTION = {
    UPSERT: 1,
    DELETE: 2
};
var ERROR_CODE;
(function(ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ERROR_CODE[ERROR_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    ERROR_CODE[ERROR_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));
var ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState || (ReadyState = {}));
var NetworkStatus;
(function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "online";
    NetworkStatus["OFFLINE"] = "offline";
})(NetworkStatus || (NetworkStatus = {}));


/***/ }),

/***/ 28840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ useSecuritiesStore; }
/* harmony export */ });
/* unused harmony exports securitiesState, securitiesActions */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);





var securitiesState = {
    channel: {},
    isReconnectionFailed: false,
    isSocketOnline: false
};
var securitiesActions = function(set) {
    return {
        setChannel: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.channel), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
                });
            });
        },
        setIsReconnectionFailed: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isReconnectionFailed = value;
                });
            });
        },
        setIsSocketOnline: function(isSocketOnline) {
            set({
                isSocketOnline: isSocketOnline
            });
        },
        resetChannel: function() {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = {};
                });
            });
        }
    };
};
var useSecuritiesStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, securitiesState, securitiesActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ SecuritiesChannel; },
/* harmony export */   "e7": function() { return /* binding */ PayloadCase; }
/* harmony export */ });
/* unused harmony exports RequestCommand, RequestChannel */
var SecuritiesChannel;
(function(SecuritiesChannel) {
    SecuritiesChannel["PING"] = "ping";
    SecuritiesChannel["AUTH"] = "auth";
    SecuritiesChannel["SECURITIES"] = "securities";
})(SecuritiesChannel || (SecuritiesChannel = {}));
var PayloadCase;
(function(PayloadCase) {
    PayloadCase["COMMAND"] = "command";
    PayloadCase["SUBSCRIBE"] = "subscribe";
    PayloadCase["UNSUBSCRIBE"] = "unsubscribe";
})(PayloadCase || (PayloadCase = {}));
var RequestCommand;
(function(RequestCommand) {
    RequestCommand[RequestCommand["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestCommand[RequestCommand["PING"] = 1] = "PING";
    RequestCommand[RequestCommand["AUTH"] = 2] = "AUTH";
})(RequestCommand || (RequestCommand = {}));
var RequestChannel;
(function(RequestChannel) {
    RequestChannel[RequestChannel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestChannel[RequestChannel["SECURITIES_LIVE_PORTO"] = 1] = "SECURITIES_LIVE_PORTO";
})(RequestChannel || (RequestChannel = {}));


/***/ }),

/***/ 46238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c$": function() { return /* binding */ createPingPayload; },
/* harmony export */   "y_": function() { return /* binding */ generateWSCookie; }
/* harmony export */ });
/* unused harmony exports getAccountNumber, createUint8Array, createSubscribePayload, createUnsubscribePayload */
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11763);
/* harmony import */ var _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17985);


var getAccountNumber = function() {
    var accountNumber = securitiesLocalStorage.getSecuritiesAccountInfo().accountNumber;
    return accountNumber !== null && accountNumber !== void 0 ? accountNumber : null;
};
var createUint8Array = function(value) {
    var textEncoder = new TextEncoder();
    return textEncoder.encode(value);
};
var createPingPayload = function() {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.COMMAND */ .e7.COMMAND,
            value: 1
        },
        value: new Uint8Array()
    };
};
var createSubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.SUBSCRIBE */ .e7.SUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var createUnsubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.UNSUBSCRIBE */ .e7.UNSUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var generateWSCookie = function(value) {
    return "gen-websocket=".concat(value, "; domain=stockbit.com; path=/v1; Secure;");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createPingPayload: createPingPayload,
    createSubscribePayload: createSubscribePayload,
    createUnsubscribePayload: createUnsubscribePayload,
    generateWSCookie: generateWSCookie
});


/***/ }),

/***/ 84468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ buttonSupportId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var utils_crisp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65458);
/* eslint-disable react/require-default-props */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: #404040;\n  border: none;\n  border-radius: 50%;\n  bottom: 50px;\n  cursor: pointer;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n  position: fixed;\n  right: 30px;\n  width: 60px;\n  z-index: 9999;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ButtonSupport = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-19608ef8-0"
})(_templateObject());
var buttonSupportId = "buttonSupport";
function SupportButton(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonSupport, {
        onClick: utils_crisp__WEBPACK_IMPORTED_MODULE_4__/* .handleClickSupport */ .lA,
        id: buttonSupportId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "icon-widget_support",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light,
            hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light,
            size: "40px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SupportButton);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "S3": function() { return /* binding */ FLIPT_DESKTOP_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "WQ": function() { return /* binding */ FLIPT_FINANCIAL_DATA_NAMESPACE; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; },
/* harmony export */   "g0": function() { return /* binding */ FLIPT_FINANCIAL_DATA_TOKEN; },
/* harmony export */   "uL": function() { return /* binding */ FLIPT_DESKTOP_TOKEN; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN;
var FLIPT_FINANCIAL_DATA_TOKEN = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN = "7BcKXp5uJ9xPlBrKLorMCGWnzM4zE6PoPkYXdh5iMys=") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE;
var FLIPT_FINANCIAL_DATA_NAMESPACE = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE = "financial-data") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN;
var FLIPT_DESKTOP_TOKEN = (_NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN = "Kmho-j0dflXhQTvnnNA7y_tkuUN16W-Sg7pUo2hWPUg=") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE;
var FLIPT_DESKTOP_NAMESPACE = (_NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE = "desktop-production") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE : "";


/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});
var fliptFinancialDataApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptFinancialDataApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0)
        });
    }
    return config;
});
var fliptDesktopApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptDesktopApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_DESKTOP_NAMESPACE */.S3) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_DESKTOP_TOKEN */.uL)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    if (service === "financial-data") {
        return fliptFinancialDataApi;
    }
    if (service.includes("desktop")) {
        return fliptDesktopApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts





var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: String(userId)
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 9:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 12;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 12:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            _ctx.next = 8;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 8:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);